// Angular imports
import { Routes } from '@angular/router';

// Application imports
import { AccountSelectedComponent } from 'app/components/account-selected/account-selected.component';
import { AccountSelectionComponent } from 'app/components/account-selection/account-selection.component';
import { ApplicationRoute } from './application-route';
import { UserAuthGuard, AdminAuthGuard } from 'app/guards/auth.guard';
import { DeploymentDetailsComponent } from 'app/components/deployment-details/deployment-details.component';
import { DeploymentsTableComponent } from 'app/components/deployment/deployments-table.component';
import { LoginComponent } from 'app/components/login-logout/login.component';
import { LogoutComponent } from 'app/components/login-logout/logout.component';
import { ProductInformationComponent } from 'app/components/product-info/product-information.component';
import { SplashComponent } from 'app/components/splash/splash.component';
import { AdminDeploymentsComponent } from 'app/components/admin-deployments/admin-deployments.component';
import { AdminSplashComponent } from 'app/components/admin-splash/admin-splash.component';
import { AdminLoginComponent } from 'app/components/admin-login/admin-login.component';
import { environment } from 'environments/environment';


// Conditionally included admin routes, OFF for prod.
const adminRoutes: Routes = environment.production
    ? []
    : [
        {
            path: ApplicationRoute.ADMIN,
            canActivate: [AdminAuthGuard],
            children: [
                { path: ApplicationRoute.DEPLOYMENTS, component: AdminDeploymentsComponent }
            ]
        },
        {
            path: ApplicationRoute.ADMIN,
            children: [
                { path: ApplicationRoute.LOGIN, component: AdminLoginComponent },
                { path: ApplicationRoute.SPLASH, component: AdminSplashComponent },
                { path: '**', redirectTo: ApplicationRoute.SPLASH }
            ]
        }
    ];

// Route configuration
export const routes: Routes = [
    { path: ApplicationRoute.NULL, redirectTo: ApplicationRoute.SPLASH, pathMatch: 'full' },

    // Fortinet customer auth - FortiCloud
    // Auth required
    {
        path: ApplicationRoute.NULL,
        canActivate: [UserAuthGuard],
        children: [
            { path: ApplicationRoute.ACCOUNT_SELECTION, component: AccountSelectionComponent },
            { path: ApplicationRoute.PRODUCT_INFORMATION, component: ProductInformationComponent },
            {
                path: ApplicationRoute.ENTITLEMENTS,
                children: [
                    { path: '', component: DeploymentsTableComponent, pathMatch: 'full' },
                    { path: ':serial', component: DeploymentDetailsComponent }
                ]
            }
        ]
    },

    // No auth
    { path: ApplicationRoute.ACCOUNT_SELECTED, component: AccountSelectedComponent },
    { path: ApplicationRoute.LOGIN, component: LoginComponent },
    { path: ApplicationRoute.LOGOUT, component: LogoutComponent },
    { path: ApplicationRoute.SPLASH, component: SplashComponent },

    // Admin routes (only in dev)
    ...adminRoutes,

    // Catch-all
    { path: '**', redirectTo: ApplicationRoute.SPLASH }
];
